import React from 'react';
import { Alert, Col, Form, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { ActionButtons } from '../../../common/components';
import { LOADING_STATUS, PRICE_CHANGE_TYPES } from '../../../common/constants';

function LastMinuteForm({
  loadingStatus,
  handleInputChange,
  handleSelectChange,
  onSubmit,
  onDelete,
  submitted,
  deleted,
  data,
  hasWriteAccess,
  isDefaultRate = false,
}: {
  loadingStatus: LOADING_STATUS;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleInputChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleSelectChange: any;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  onSubmit: any;
  onDelete?: any;
  submitted: boolean;
  deleted?: boolean;
  data: any;
  hasWriteAccess: boolean;
  isDefaultRate?: boolean;
}) {
  const priceChangeOptions = PRICE_CHANGE_TYPES.map(priceChangeType => {
    return {
      value: priceChangeType.priceChangeType,
      label: priceChangeType.description,
    };
  });

  return (
    <>
      {loadingStatus === LOADING_STATUS.LOADING && (
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">Ladataan...</span>
        </Spinner>
      )}
      {loadingStatus === LOADING_STATUS.IDLE && (
        <>
          <Form.Group controlId="daysUntilStart" className="mb-24">
            <Form.Label>Päivämäärä rajaus</Form.Label>
            <Form.Control
              type="text"
              name="daysUntilStart"
              onChange={handleInputChange}
              value={data.daysUntilStart || ''}
              placeholder="Anna vuorokausien lukumäärä"
              readOnly={!hasWriteAccess}
            />
            <Form.Text className="text-muted">
              Äkkilähtö hinnan muutos voimassa mikäli varauksen alkamispäivä on
              määritellyn rajauksen sisällä.
            </Form.Text>
          </Form.Group>

          <hr className="hr-light mb-32" />

          <Form.Group className="mb-24">
            <Form.Label>Hinnan muutoksen tyyppi</Form.Label>
            <Select
              inputId="priceChange.priceChangeType"
              name="priceChange.priceChangeType"
              placeholder="Valitse tyyppi..."
              isClearable
              isSearchable
              options={priceChangeOptions}
              onChange={option =>
                handleSelectChange(option, 'priceChange.priceChangeType')
              }
              value={priceChangeOptions.filter(
                option => option.value === data.priceChange.priceChangeType,
              )}
              classNames={{
                control: state => 'form-control form-control-react-select',
              }}
              isDisabled={!hasWriteAccess}
            />
          </Form.Group>

          {data.priceChange.priceChangeType === 1 && (
            <Form.Group controlId="priceChange.difference" className="mb-24">
              <Form.Label>Hinnan kiinteä muutos</Form.Label>
              <Form.Control
                type="text"
                name="priceChange.difference"
                onChange={handleInputChange}
                value={data.priceChange.difference || ''}
                readOnly={!hasWriteAccess}
              />
            </Form.Group>
          )}

          {data.priceChange.priceChangeType === 2 && (
            <Form.Group controlId="priceChange.percent" className="mb-24">
              <Form.Label>Hinnan prosentuaalinen muutos</Form.Label>
              <Form.Control
                type="text"
                name="priceChange.percent"
                onChange={handleInputChange}
                value={data.priceChange.percent || ''}
                readOnly={!hasWriteAccess}
              />
            </Form.Group>
          )}

          <hr className="hr-light mt-40 mb-32" />

          {isDefaultRate ? (
            <>
              <input type="hidden" name="isActive" value="true" />
              <input type="hidden" name="isCopyable" value="true" />
            </>
          ) : (
            <Row xs="auto">
              <Col>
                <Form.Group controlId="isActive" className="mb-24">
                  <Form.Label>Aktiivinen sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isActive"
                    onChange={handleInputChange}
                    checked={data.isActive}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="isCopyable" className="mb-24">
                  <Form.Label>Kopioitava sääntö</Form.Label>
                  <Form.Check
                    type="checkbox"
                    name="isCopyable"
                    onChange={handleInputChange}
                    checked={data.isCopyable}
                    disabled={!hasWriteAccess}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <ActionButtons
            HandleSave={onSubmit}
            HideSaveButton={!hasWriteAccess}
            HideCancelButton
            DeleteButtonText="Poista"
            HandleDelete={onDelete}
          />
          {submitted && (
            <div className="mt-2 pt-2">
              <Alert variant="success">Tiedot tallennettu!</Alert>
            </div>
          )}
          {deleted && (
            <div className="mt-2 pt-2">
              <Alert variant="danger">Sääntö poistettu!</Alert>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default LastMinuteForm;
